import React from 'react'
import WhatsappTemplatePreview from './WhatsappTemplatePreview'
import { buildPreviewComponentsFromTemplate } from '../../screens/admin/cdp/WhatsappPreviewAdapter'
import { previewSlotsFromFormData, slotsFromStructure } from '../../screens/admin/cdp/whatsapp-chatbot/chatbotTemplateForm'

function fieldLink(context, linkName) {
  const fields = context && context.formDefinition && context.formDefinition.steps
    && context.formDefinition.steps[0] && context.formDefinition.steps[0].fields
  if (!Array.isArray(fields) || !linkName) return ''
  for (let i = 0; i < fields.length; i++) {
    const f = fields[i]
    if (f && f.linkName === linkName && f.link) return f.link
  }
  return ''
}

function structureFromContext(formData, def) {
  const templateId = formData && formData.templateId
  const tpl = def && def.templatesByName && templateId ? def.templatesByName[templateId] : null
  if (tpl && Array.isArray(tpl.components)) return tpl.components
  if (def && Array.isArray(def.templateStructure)) return def.templateStructure
  return []
}

function slotsFromContext(def, structure) {
  if (def && Array.isArray(def.templateSlots) && def.templateSlots.length) return def.templateSlots
  return slotsFromStructure(structure)
}

export default function ChatbotTemplatePreviewAdapter({ formData, context }) {
  const def = context && context.formDefinition
  const structure = structureFromContext(formData, def)
  const slots = previewSlotsFromFormData(formData, slotsFromContext(def, structure)).map(slot => {
    if (!slot || String(slot.format || '').toLowerCase() === 'text') return slot
    const fromField = fieldLink(context, 'slot_' + slot.id + '_mediaLink')
    if (fromField && !slot.mediaLink) return { ...slot, mediaLink: fromField }
    return slot
  })
  const components = buildPreviewComponentsFromTemplate(structure, slots, { hideTemplateExamplesWhenUnset: true })
  return <WhatsappTemplatePreview components={components} />
}
